import { JsonErrorResponse } from '../json-response.interface';

export class ExternalErrorException extends Error {
    private readonly externalMessage: string;
    private readonly code: string|null;
    private readonly data: object;

    private constructor(externalMessage: string, code: string|null = null, data: object = {}) {
        let message = `External server error: ${externalMessage}.`;
        if (code) {
            message = `${message} With error code: ${code}.`
        }
        if (data) {
            message = `${message} With the following data ${JSON.stringify(data)}`
        }
        super(message);

        this.externalMessage = externalMessage;
        this.code = code;
        this.data = data;
    }

    public static createFromJsonErrorResponse(response: JsonErrorResponse): ExternalErrorException {
        const code = response.code ? response.code : null;
        const data = response.data ? response.data : {};
        return new ExternalErrorException(response.message, code, data);
    }

    public getExternalMessage(): string {
        return this.externalMessage;
    }

    public getCode(): string|null {
        return this.code;
    }

    public getData(): object {
        return this.data;
    }
}
